import React from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import styles from "./style.module.scss";

const AllBlogPosts = ({ allBlogPosts, currentPost = {} }) => {
  return (
    <div className={styles.allPosts}>
      <h3>More posts</h3>
      {allBlogPosts.edges.map(({ blogPost }) => (
        <div key={blogPost.id}>
          {blogPost.id === currentPost.id ? (
            <strong>{blogPost.title}</strong>
          ) : (
            <Link to={`blog/${blogPost.slug}`}>{blogPost.title}</Link>
          )}
        </div>
      ))}
    </div>
  );
};

AllBlogPosts.defaultProps = {
  currentPost: {}
};

AllBlogPosts.propTypes = {
  allBlogPosts: PropTypes.shape({
    edges: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        slug: PropTypes.string
      })
    )
  }).isRequired,
  currentPost: PropTypes.shape({
    title: PropTypes.string,
    slug: PropTypes.string
  })
};

export default AllBlogPosts;
